const t = "DS", a = 16, s = 1920, o = "https://platform-api.qa.datassential.com", I = "https://platform-api.staging.datassential.com", _ = "https://platform-api.datassential.com";
export {
  _ as API_LINK_LIVE,
  o as API_LINK_QA,
  I as API_LINK_STAGING,
  t as CSS_PREFIX,
  a as REM_FONT_SIZE,
  s as SCALE_FROM_VIEWPORT_SIZE
};
